import * as React from 'react';
import styled from 'styled-components';
import ActivityTag from './ActivityTag';
import DownloadImage from '../../assets/ic-download.png';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const ActivityHeader = ({activity, gridSize}) => {
    let {t} = useTranslation();
    return (
        <HeaderContainer backgroundColor={activity.color} gridSize={gridSize}>
            <CharImage src={activity.charImage} />

            <TitleText>{activity.title}</TitleText>
            <WrapLink href={activity.file} target="_blank" download>
                <DownloadButton>
                    <Image src={DownloadImage} />
                    <DownloadText>
                        {t('parentalPage.activities.openCTA')}
                    </DownloadText>
                </DownloadButton>
            </WrapLink>
            <Tag activity={activity} />
        </HeaderContainer>
    );
};

const HeaderContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    grid-column-start: 1;
    grid-column-end: ${props => props.gridSize + 1};
    height: 260px;
    position: relative;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
`;

const CharImage = styled.img`
    width: 394px;
    height: 286px;
    position: absolute;
    transform: scale(1.1);
    bottom: 0px;
    left: 400px;
    transform-origin: bottom;
`;

const TitleText = styled.p`
    font-family: 'Oduda';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    text-transform: uppercase;
    color: black;
    margin-block: 0;
    padding: 52px 0px 20px 63px;
    max-width: 330px;
`;

const Tag = styled(ActivityTag)`
    position: absolute;
    right: 13px;
    bottom: 17px;
`;

const DownloadButton = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
    margin-left: 63px;
    background-color: #3577f4;
    padding: 10px 18px;
    border-radius: 12px;
`;

const Image = styled.img`
    margin-right: 10px;
    align-self: center;
`;

const DownloadText = styled.div`
    font-family: 'Oduda';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;
    color: white;
`;

const WrapLink = styled.a`
    align-self: flex-start;
    color: transparent;
`;

export default ActivityHeader;
